import request from '@/config/axios'

const BASE='/hotel/platform/management'
export const getContracts=(params?:any)=>request.get({url:`${BASE}/contracts`,params})
export const getQualifications=(params?:any)=>request.get({url:`${BASE}/qualifications`,params})
export const getContentVersions=(params?:any)=>request.get({url:`${BASE}/content`,params})
export const auditContent=(data:any)=>request.post({url:`${BASE}/content/audit`,data})
export const publishContent=(id:string|number)=>request.post({url:`${BASE}/content/publish`,params:{id}})
export const getPlatformChannels=(params?:any)=>request.get({url:`${BASE}/channels`,params})
export const getPlatformMembers=(params?:any)=>request.get({url:`${BASE}/members`,params})
export const getPlatformRentPolicies=(params?:any)=>request.get({url:`${BASE}/rent-policies`,params})
